import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Card } from "../../../../_metronic/_partials/controls";
import backArrow from "../../../../assets/img/company/logsBackArrow.svg";
import downloadIcon from "../../../../assets/img/company/donwloadIcon.svg";
import blueTickIcon from "../../../../assets/img/company/blueTickIcon.svg";
import redCrossIcon from "../../../../assets/img/company/redCrossIcon.svg";
import copyIcon from "../../../../assets/img/copyIcon.svg";
import * as zatcaActions from "../../../../_redux/zatca/zatcaActions";
import toast from "react-hot-toast";
import { generateAllInvoiceLogsXML, generateLogsXML } from "../../../../helpers/helpers";
import moment from "moment";
import { useDispatch } from "react-redux";
function ViewLogsModal({ show, onHide, invoiceData, invoiceLogs, handleLoadMoreLogs, totalLogsCount }) {
  const language = localStorage.getItem("language");
  const [allLogs, setAllLogs] = useState([]);
  useEffect(() => {
    let refactoredLogs = invoiceLogs?.map((item) => {
      return {
        ...item,
        status: item?.logMessage?.toLowerCase()?.includes("created")
          ? "Created"
          : item?.logMessage?.toLowerCase()?.includes("sync") && item?.additionalInfo?.moreDetails?.failReason?.length === 0
          ? "Synced"
          : item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
          ? "Failed"
          : "Success",
        title: item?.logMessage,
        isExpanded: false,
        details: [
          // { heading: "Time", description: item?.createdAt },
          { heading: "Time", description: item?.additionalInfo?.moreDetails?.formattedDate || item?.additionalInfo?.formattedDate },
          { heading: "Invoice ID", description: item?.additionalInfo?.invoiceName || item?.additionalInfo?.invoiceId },
          ...(item?.createdBy === "System"
            ? [
                {
                  heading: "Invoice UUID",
                  description: item?.additionalInfo?.invoiceUUID,
                },

                (item?.logMessage?.includes("Submit") ||
                  item?.logMessage?.includes("Zatca Response") ||
                  item?.logMessage?.includes("Sign Invoice")) && {
                  heading: "Invoice Hash",
                  description: item?.additionalInfo?.invoiceHash,
                },
                (item?.logMessage?.includes("Submit") ||
                  item?.logMessage?.includes("Generate") ||
                  (item?.logMessage?.includes("Sign Invoice") && item?.additionalInfo?.response !== "Failed")) && {
                  heading: "Previous Invoice Hash",
                  description: item?.additionalInfo?.previousInvoiceHash,
                },
                item?.logMessage?.includes("Submit") && {
                  heading: "Channel",
                  description: item?.additionalInfo?.channel,
                },
                item?.logMessage?.includes("Submit") && {
                  heading: "Endpoint",
                  description: item?.additionalInfo?.endpoint,
                },

                item?.logMessage?.includes("Sign") && {
                  heading: "Certificate Type",
                  description: item?.additionalInfo?.envType,
                },

                item?.logMessage?.includes("Sign") && {
                  heading: "CSID",
                  description: item?.additionalInfo?.certificateId,
                },

                item?.logMessage?.includes("Validate") && {
                  heading: "Validation Result",
                  description: item?.additionalInfo?.response === "Failed" ? "Failed" : "Passed",
                },

                item?.logMessage?.includes("Validate") && {
                  heading: "XSD Version",
                  description: "ZATCA-UBL-2.1-v1.0",
                },
              ].filter(Boolean)
            : []),

          ...(item?.additionalInfo?.moreDetails?.invoiceReference?.length > 0
            ? [{ heading: "Invoice Reference", description: item?.additionalInfo?.moreDetails?.invoiceReference }]
            : []),
          {
            heading: "POS ID",
            description: item?.additionalInfo?.moreDetails?.posId ? item?.additionalInfo?.moreDetails?.posId : item?.additionalInfo?.posId,
          },
          { heading: "Store ID", description: item?.additionalInfo?.moreDetails?.storeId || item?.additionalInfo?.storeId },
          {
            heading: "Actor",
            description: (
              <>
                {item?.createdBy === "System" ||
                item?.additionalInfo?.moreDetails?.initiatedBy === "system" ||
                item?.additionalInfo?.initiatedBy === "system" ? (
                  <div>System</div>
                ) : (
                  <>
                    {" "}
                    <div>ID: {item?.additionalInfo?.moreDetails?.actor?.id}</div>
                    <div>Name: {item?.additionalInfo?.moreDetails?.actor?.name}</div>
                  </>
                )}
              </>
            ),
          },
          ...(item?.logMessage?.includes("Sync")
            ? [
                {
                  heading: "Attempt No",
                  description: item?.additionalInfo?.moreDetails?.attemptNo || item?.additionalInfo?.attemptNo,
                },
              ]
            : []),

          ...(item?.logMessage?.includes("Submit") || item?.logMessage?.includes("Zatca Response")
            ? [
                {
                  heading: "Request ID",
                  description: item?.additionalInfo?.requestId,
                },
                {
                  heading: "Request Time",
                  description: item?.additionalInfo?.requestTime
                    ? moment(item?.additionalInfo?.requestTime)
                        .utc()
                        .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
                    : "",
                },
                {
                  heading: "Response ID",
                  description: item?.additionalInfo?.responseId,
                },
                {
                  heading: "Response Time",
                  description: item?.additionalInfo?.responseTime
                    ? moment(item?.additionalInfo?.responseTime)
                        .utc()
                        .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
                    : "",
                },
              ]
            : []),
          item?.logMessage?.includes("Submit") && {
            heading: "Submission Type",
            description: item?.additionalInfo?.submissionType,
          },
          item?.logMessage?.includes("Submit") && {
            heading: "Attempt No",
            description: item?.additionalInfo?.attemptNo,
          },
          {
            heading: item?.additionalInfo?.moreDetails?.type === "Download XML" ? "Action Type" : "Invoice Type",
            description: item?.additionalInfo?.moreDetails?.type || item?.additionalInfo?.type,
          },
          item?.logMessage?.includes("Log XML") && {
            heading: "File Name",
            description: item?.additionalInfo?.moreDetails?.fileName,
          },
          ...(item?.logMessage?.includes("Generate") || item?.logMessage?.includes("Validate")
            ? [
                {
                  heading: "XML Ref",
                  description: item?.additionalInfo?.xmlRef,
                },
              ]
            : []),
          ...(item?.logMessage?.includes("Generate")
            ? [
                {
                  heading: "XML Hash",
                  description: item?.additionalInfo?.xmlHash,
                },
              ]
            : []),
          ...(item?.logMessage?.includes("Zatca Response")
            ? [
                {
                  heading: "Processing Time (seconds)",
                  description: Number(item?.additionalInfo?.processingTime)?.toFixed(2),
                },
              ]
            : []),
          item?.logMessage?.includes("Sign Invoice") &&
            item?.additionalInfo?.response !== "Failed" && {
              heading: "Signature Hash",
              description: item?.additionalInfo?.signatureHash,
            },
          item?.logMessage?.includes("Sign Invoice") &&
            item?.additionalInfo?.response !== "Failed" && {
              heading: "Digital Signature Value",
              description: item?.additionalInfo?.digitalSignatureValue,
            },
          (item?.logMessage?.includes("Sign") ||
            item?.logMessage?.includes("Validate") ||
            item?.logMessage?.includes("Zatca Response") ||
            item?.logMessage?.includes("Sync")) &&
            (item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail") && {
              heading: "Error Message",
              description: item?.additionalInfo?.failReason || item?.additionalInfo?.moreDetails?.failReason,
            },
          item?.logMessage?.includes("Zatca Response") &&
            item?.additionalInfo?.response === "Failed" && {
              heading: "Error Code",
              description: item?.additionalInfo?.failResponseCode,
            },
          {
            heading: "Status",
            description: (
              <span style={{ fontWeight: "700", color: "#404040" }}>
                {item?.logMessage?.toLowerCase()?.includes("created")
                  ? "Created"
                  : item?.logMessage?.toLowerCase()?.includes("sync") && item?.additionalInfo?.moreDetails?.failReason?.length === 0
                  ? "Synced"
                  : item?.additionalInfo?.response || item?.additionalInfo?.moreDetails?.status}
              </span>
            ),
          },
        ],
      };
    });
    setAllLogs([...refactoredLogs]);
  }, [invoiceLogs]);

  const handleExpandItem = (id) => {
    let refactoredData = allLogs?.map((item) => {
      return { ...item, isExpanded: id === item?._id ? !item?.isExpanded : false };
    });
    setAllLogs([...refactoredData]);
  };
  const dispatch = useDispatch();

  const handleDownloadInvoiceLog = (id) => {
    let selectedInvoice = invoiceLogs?.find((item) => item._id === id);

    const xml = generateLogsXML(selectedInvoice);
    const invoiceId = selectedInvoice?.additionalInfo?.invoiceName;
    const blob = new Blob([xml], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);
    const timestamp = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15); // YYYYMMDDThhmm

    const a = document.createElement("a");
    a.href = url;
    a.download = `${invoiceId}_log_${timestamp}.xml`;
    a.click();
    dispatch(
      zatcaActions.createInvoiceXmlDownloadLogs(
        invoiceData?.company?._id,
        invoiceData?._id,
        "Log XML Downloaded",
        `${invoiceId}_log_${timestamp}.xml`,
      ),
    );
    toast.success("XML generated successfully");
  };

  const handleDownloadAllZatcaLogs = () => {
    if (!invoiceLogs || invoiceLogs.length === 0) return;

    const xml = generateAllInvoiceLogsXML(allLogs);
    const blob = new Blob([xml], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);
    const timestamp = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${invoiceData?.invoiceData?.invoiceNumber}_logs_${timestamp}.xml`;
    a.click();
    window.URL.revokeObjectURL(url);
    dispatch(
      zatcaActions.createInvoiceXmlDownloadLogs(
        invoiceData?.company?._id,
        invoiceData?._id,
        "Log XML Downloaded",
        `${invoiceData?.invoiceData?.invoiceNumber}_logs_${timestamp}.xml`,
      ),
    );
    toast.success("XML generated successfully");
  };

  return (
    <div>
      <Modal
        className={`${language === "arabic" ? "modal-dialog-arabic modal-drawer rtl" : " modal-drawer ltr"}  my-profile invoice-drawer`}
        size="lg"
        show={show}
        onHide={() => {}}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <div className="bg-white">
          <div className={`d-flex align-items-center p-4 ${language === "arabic" ? "flex-row-reverse" : "flex-row"}`}>
            <div
              onClick={() => {
                onHide();
              }}
              className="cursor-pointer"
            >
              <img src={backArrow} alt="back" style={{ width: "8px" }} />
            </div>

            <Modal.Title className="ml-auto mr-auto" style={{ color: "#333333", fontSize: "16px", fontWeight: 700 }}>
              Invoice <span>{invoiceData?.invoiceData?.invoiceNumber}</span> Log
            </Modal.Title>
            <div className="cursor-pointer" onClick={handleDownloadAllZatcaLogs}>
              <img src={downloadIcon} alt="back" />
            </div>
          </div>
        </div>

        <Modal.Body className="overlay overlay-block cursor-default p-4" style={{ background: "#F2F2F2" }}>
          <div className={` ${language === "arabic" ? " text-right" : "text-left"}`}>
            <div>
              {allLogs?.map((item) => {
                return (
                  <>
                    <Card className="rounded mx-1 cursor-pointer">
                      <div>
                        {item?.isExpanded ? (
                          <div className="d-flex pb-4" style={{ gap: "1rem" }}>
                            <div className="position-relative relative">
                              {" "}
                              <img
                                src={
                                  item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
                                    ? redCrossIcon
                                    : blueTickIcon
                                }
                                alt="tick"
                              />
                              <div
                                className="vertical-line"
                                style={{ position: "absolute", width: "2px", background: "#DEE5E9", height: "94%", left: "7px", top: "1.8rem" }}
                              ></div>
                            </div>
                            <div className="w-100" style={{ fontSize: "16px", fontWeight: 400, marginTop: "-3px" }}>
                              <div className="w-100 d-flex justify-content-between">
                                <div style={{ color: "#236DD1" }} className="pb-2">
                                  {item?.title}
                                </div>
                                <div className="cursor-pointer" onClick={() => handleDownloadInvoiceLog(item?._id)}>
                                  <img src={copyIcon} alt="" />
                                </div>
                              </div>
                              {item?.details?.map((subItem) => {
                                return (
                                  <div onClick={() => handleExpandItem(item?._id)}>
                                    <div className="logs-small-text pt-1">{subItem?.heading}</div>
                                    <div className="logs-normal-text" style={{ maxWidth: "19rem", width: "auto" }}>
                                      {subItem?.description}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex pb-4" style={{ gap: "1rem", marginTop: "-3px" }} onClick={() => handleExpandItem(item?._id)}>
                            <div className="position-relative relative">
                              {" "}
                              <img
                                src={
                                  item?.additionalInfo?.response === "Failed" || item?.additionalInfo?.moreDetails?.status === "Fail"
                                    ? redCrossIcon
                                    : blueTickIcon
                                }
                                alt="tick"
                              />
                              <div
                                className="vertical-line"
                                style={{ position: "absolute", width: "2px", background: "#DEE5E9", height: "68%", left: "7px", top: "1.8rem" }}
                              ></div>
                            </div>
                            <div className="d-flex justify-content-between w-100">
                              <div style={{ fontSize: "16px", fontWeight: 400, marginTop: "-3px" }}>
                                <div style={{ color: "#236DD1" }} className="pb-2">
                                  {item?.title}
                                </div>
                                <div style={{ fontSize: "14px" }}>
                                  {item?.additionalInfo?.moreDetails?.formattedDate || item?.additionalInfo?.formattedDate}
                                </div>
                                <div style={{ fontSize: "14px" }}>
                                  {item?.additionalInfo?.moreDetails?.initiatedBy === "system" || item?.additionalInfo?.initiatedBy === "system"
                                    ? "System"
                                    : item?.createdBy}
                                </div>
                              </div>
                              <div style={{ color: "#333333" }}>{item?.status}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Card>
                  </>
                );
              })}
              {Number(totalLogsCount) > Number(invoiceLogs?.length) ? (
                <div style={{ cursor: "pointer" }} onClick={handleLoadMoreLogs}>
                  Load More
                </div>
              ) : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ViewLogsModal;
